import * as generatedEndpoints from './api-endpoint-definition.json';

const endpoints = {
    ...generatedEndpoints
}

export default endpoints;